import './style/index.less';
import AccountForm from './AccountForm';

export * from './AccountForm';

export default AccountForm;
